'use client';

import { useIsMobile } from '@shared/utils';
import { usePathname } from 'next/navigation';
import { matchGamePlayPathname } from '../../utils';

/**
 * useShouldShowWalletBalance checks if the user should show the wallet balance.
 * It is expected that user balance should be hidden when user is on desktop and
 * has active game session - this is needed to prevent synchronization issues between the wallet balance and the game session.
 * @returns True if the user should show the wallet balance, false otherwise.
 */
function useShouldShowWalletBalance() {
  const pathname = usePathname();
  const isMobile = useIsMobile({ breakpoint: 'md' });
  const isGamePage = matchGamePlayPathname(pathname || '');
  return !isGamePage || isMobile;
}

export { useShouldShowWalletBalance };
